<template lang="pug">
.stat-card(
  :class="[cardClass, { 'stat-centered': centrado }]"
  @click="$emit('click')"
)
  .stat-indicator
  .stat-information
    span.stat-title
      | {{ titulo }}
    span.stat-description(v-if="descripcion")
      | {{ descripcion }}
    .stat-footer
      strong.stat-value
        | {{ cantidad }}
      span.stat-link
        | Ver detalle
        span.arrow
          | →
</template>
<script>
export default {
  name: 'StatCard',
  props: {

    titulo: String,

    descripcion: String,

    cantidad: {
      type: Number,
      default: 0
    },

    tipo: {
      type: String,
      default: 'primary'
    },

    centrado: {
      type: Boolean,
      default: false
    }

  },
  computed: {
    cardClass () {
      return 'stat-' + this.tipo
    }
  }
}
</script>
<style scoped>
.stat-card {
  position: relative;

  min-height: 125px;

  padding: 20px 22px;

  display: flex;

  background: white;

  border: 1px solid #e1e4e8;

  border-radius: 9px;

  cursor: pointer;

  overflow: hidden;

  transition:
    transform .18s ease,
    box-shadow .18s ease,
    border-color .18s ease;
}
.stat-card:hover {
  transform: translateY(-2px);
  border-color: #d2d5db;
  box-shadow:
    0 7px 20px rgba(0,0,0,.06);
}
.stat-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #714b67;
}
.stat-danger .stat-indicator {
  background: #dc3545;
}
.stat-warning .stat-indicator {
  background: #f0ad4e;
}
.stat-info .stat-indicator {
  background: #17a2b8;
}
.stat-primary .stat-indicator {
  background: #714b67;
}
.stat-information {
  flex: 1;
}
.stat-title {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #31363b;
}
.stat-description {
  display: block;
  margin-top: 3px;
  font-size: 11px;
  color: #90959c;
}
.stat-footer {
  margin-top: 14px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.stat-value {
  font-size: 28px;
  line-height: 1;
  color: #30343b;
}
.stat-link {
  font-size: 11px;
  color: #714b67;
  font-weight: 600;
}
.arrow {
  margin-left: 5px;
}
.stat-centered .stat-information {
  text-align: center;
}

.stat-centered .stat-title {
  text-align: center;
}

.stat-centered .stat-description {
  text-align: center;
}
.stat-centered .stat-footer {
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 10px;

  margin-top: 13px;
}

.stat-centered .stat-value {
  text-align: center;
}

.stat-centered .stat-link {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// c_statCard.vue?6cb88e2d